import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {isMobile} from 'react-device-detect';
import { useEthers } from '@usedapp/core';
import Button from '@mui/material/Button';
import { WalletsModal } from "./WalletsModal";


export const ConnectButton = ({setReadOnlyMode}: any) => {

  const [walletModalOpen, setWalletModalOpen] = useState(false);
  const { activateBrowserWallet } = useEthers();
  const navigate = useNavigate();


  const onWalletModalOpen = () => {
    if(isMobile){
      activateBrowserWallet({ type: 'walletConnectV2' });
      backToSummary();
    } else {
      setWalletModalOpen(true);
    }
    
  };

  const backToSummary = () => {
    navigate("/");
    setReadOnlyMode(false);
  }

  return (
    <>
      <Button className={'header__button onlyMobile'} sx={{margin: '50px auto 0 auto', height: '52px !important', borderRadius: '24px !important', color: "#fff", textTransform: 'none', fontSize: '16px'}} onClick={onWalletModalOpen}>
            <a>Connect Wallet</a>
      </Button>
      <WalletsModal open={walletModalOpen} onClose={() => {setWalletModalOpen(false); backToSummary();}} />
    </>
  )
};